<fs-label-field>
  <fs-label>{{label}}</fs-label>
  <app-attribute-pills [attributes]="attributes" [allSelected]="true">
    <a (click)="openSelector()" class="select">Select</a>
  </app-attribute-pills>
</fs-label-field>
